// extracted by mini-css-extract-plugin
module.exports = {"public_page":"_public-page_public_page__K3olM"};